<div class="overlay" *ngIf="IsWait">
    <div class="center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
</div>

<div class="wrapper">
    <div class="flex-wrapper">
        <button mat-flat-button color="primary" (click)="create()" *ngIf="!hideCreateBtnFor.includes(router.url)">
            <mat-icon>add</mat-icon> Create
        </button>

        <mat-slide-toggle *ngIf="!hideActiveToggleFor.includes(router.url)" [checked]="activeView" (change)="onToggleActive($event)" color="primary">
            {{ activeView ? 'Active' : 'Inactive' }}
        </mat-slide-toggle>

        <mat-chip-listbox *ngIf="selectedIds.length > 0" class="selected-chip">
            <mat-chip>Selected: {{ selectedIds.length }}</mat-chip>
        </mat-chip-listbox>

        <button mat-flat-button class="secondary-button" *ngIf="allIds.length > 0 && selectedIds.length < allIds.length" (click)="selectAllRecords()">Select All {{ allIds.length }} Records</button>
        <button mat-flat-button class="secondary-button" *ngIf="allIds.length > 0 && selectedIds.length === allIds.length" (click)="unselectAllRecords()">Unselect All {{ allIds.length }} Records</button>

        <button mat-flat-button color="warn" *ngIf="!hideActiveToggleFor.includes(router.url) && selectedIds.length > 0" (click)="bulkAction()">
            {{ activeView ? 'Deactivate' : 'Restore' }}
        </button>

        <button mat-flat-button class="warn-button" *ngIf="showBulkAction.includes(router.url) && selectedIds.length > 0" [innerHTML]="(speaker.model == 'challan') ? 'Generate Proforma' : 'Generate Invoice'" (click)="generateBulk(speaker.model)">
        </button>

        <span class="spacer"></span>
    </div>
</div>

<div class="mat-table-container">
    <table mat-table matSort (matSortChange)="onSortChange($event)" [dataSource]="dataSource" class="mat-elevation-z2">
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox color="primary" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="action" *ngIf="speaker.showActionColumn">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
                <button type="button" mat-flat-button color="primary" class="action-row-btn" (click)="$event.stopPropagation(); speaker.emitActionClick(row)">
                    {{ speaker.actionColumnLabel || 'Action' }}
                </button>
            </td>
        </ng-container>

        <ng-container class="mat-table-row" [matColumnDef]="column" *ngFor="let column of displayColumns; let i = index;">
            <th class="font-weight-bold" mat-header-cell mat-sort-header *matHeaderCellDef> {{ displayHeaders[i] }} </th>
            <td mat-cell *matCellDef="let obj" (click)="rowClicked(obj.id)" class="header-cell">
                <ng-container *ngIf="column === 'product_names' || column === 'job_order_product_names'; else dateCheck">
                    <span [innerHTML]="replaceNewlinesWithBr(obj[column])"></span>
                </ng-container>
                <ng-template #dateCheck>
                    <ng-container *ngIf="dateColumns.includes(column) && obj[column]; else statusCheck">
                        {{ obj[column] | date:'dd MMM yyyy':'Asia/Kolkata' }}
                    </ng-container>
                </ng-template>
                <ng-template #statusCheck>
                    <ng-container *ngIf="column === 'status' && obj[column]; else enumCheck">
                        <span class="status-badge" [ngClass]="'status-' + obj[column]">
                            {{ formatEnumValue(obj[column]) }}
                        </span>
                    </ng-container>
                </ng-template>
                <ng-template #enumCheck>
                    <ng-container *ngIf="enumColumns.includes(column) && obj[column]; else defaultCell">
                        {{ formatEnumValue(obj[column]) }}
                    </ng-container>
                </ng-template>
                <ng-template #defaultCell>
                    {{ obj[column] }}
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumnsWithSelect"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumnsWithSelect;"></tr>
    </table>
</div>

<mat-paginator (page)="handlePageEvent($event)" [length]="length" [pageSize]="pageSize" [showFirstLastButtons]="showFirstLastButtons" [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageIndex" aria-label="Select page">
</mat-paginator>